import React from 'react';

import LinkButton from 'Components/LinkButton';
import TransitionComponent from 'Components/TransitionComponent';

import { Content, ContentWrap, ErrorIcon, SuccessIcon, Wrapper } from './styled';

export interface InlineNotificationProps {
  message: string;
  type?: 'success' | 'error';
  fadeOutDelay?: number;
  onClose?: () => void;
  visible?: boolean;
}

export const InlineNotification: React.FC<InlineNotificationProps> = ({
  type = 'success',
  message,
  onClose,
  visible
}) => (
  <TransitionComponent visible={visible} transitionType='fadeInUp'>
    <Wrapper type={type}>
      <ContentWrap>
        {type === 'success' && <SuccessIcon />}
        {type === 'error' && <ErrorIcon />}
        <Content data-testid='InlineNotification'>{message}</Content>
      </ContentWrap>
      <LinkButton onClick={onClose} data-testid='InlineNotificationDismiss'>
        Dismiss
      </LinkButton>
    </Wrapper>
  </TransitionComponent>
);

export default InlineNotification;
